export default __webpack_public_path__ + "static/media/chooose-blue.7532f65a.svg";